import {useQuery} from 'react-query';
import {useSetRecoilState} from 'recoil';
import {singleNews} from '../state/news';
import actions from '../api/news';

const useFetchSingleNews = (id: number) => {
  const setSingleNews = useSetRecoilState(singleNews);
  return useQuery('fetchSingleNews', async () => {
    const singleNews = await actions.fetchSingleNews(id);
    setSingleNews(singleNews?.data);
    return singleNews;
  });
};

export default useFetchSingleNews;
